module.exports = __webpack_public_path__ + "img/celue.bcb90fe1.png";